import axios from '@/libs/api.request'
import {getToken} from '@/libs/util'
import config from '@/config'

// const baseCloudUrl = 'http://127.0.0.1:8002/api/1.0/flow/Image/'
// 容器云基础URL
const baseCloudUrl = config.baseCloudUrl
const cloudUrl = baseCloudUrl + '/api/1.0/cloud/'

const baseHeaders = {
  'Authorization': 'OPS ' + getToken()
}

// 查询容器镜像列表
export const getImageList = (params) => {
  return axios.request({
    url: cloudUrl + 'image/list',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const saveImage = (data) => {
  return axios.request({
    url: cloudUrl + 'image/create',
    headers: baseHeaders,
    data: data,
    method: 'post'
  })
}

export const getImageDetail = (params) => {
  return axios.request({
    url: cloudUrl + 'image/' + params.id,
    headers: baseHeaders,
    method: 'get'
  })
}

export const editImage = (data) => {
  return axios.request({
    url: cloudUrl + 'image/' + data.id,
    headers: baseHeaders,
    data: data,
    method: 'put'
  })
}

export const deleteImage = (id) => {
  return axios.request({
    url: cloudUrl + 'image/' + id,
    headers: baseHeaders,
    method: 'delete'
  })
}

// 查询节点列表
export const getNodeList = () => {
  return axios.request({
    url: cloudUrl + 'node/list',
    headers: baseHeaders,
    method: 'get'
  })
}

// 查询节点详情
export const getNodeDetail = (name) => {
  return axios.request({
    url: cloudUrl + 'node/' + name,
    headers: baseHeaders,
    method: 'get'
  })
}

// 查询节点使用情况
export const getNodeUse = (name) => {
  return axios.request({
    url: cloudUrl + 'node/' + name + '/use',
    headers: baseHeaders,
    method: 'get'
  })
}

// 查询Pod列表
export const getPodList = (params) => {
  return axios.request({
    url: cloudUrl + 'pod/list',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const deletePod = (name) => {
  return axios.request({
    url: cloudUrl + 'pod/' + name,
    headers: baseHeaders,
    method: 'delete'
  })
}

export const getPodLogs = (params) => {
  return axios.request({
    url: cloudUrl + 'pod/log',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const getPodDetail = (params) => {
  return axios.request({
    url: cloudUrl + 'pod/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

// 查询Pod使用情况
export const getPodUse = (name) => {
  return axios.request({
    url: cloudUrl + 'pod/' + name + '/use',
    headers: baseHeaders,
    method: 'get'
  })
}

// 更新Deployment yaml
export const execPod = (data) => {
  return axios.request({
    url: cloudUrl + 'pod/exec/',
    headers: baseHeaders,
    data: data,
    method: 'post'
  })
}

// 查询volumes列表
export const getVolumesList = () => {
  return axios.request({
    url: cloudUrl + 'volumes/list',
    headers: baseHeaders,
    method: 'get'
  })
}

// 查询Deployment列表
export const getDeploymentList = (params) => {
  return axios.request({
    url: cloudUrl + 'deployment/list',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

// 更新Deployment pod num 数量
export const editDeploymentPodNum = (params) => {
  return axios.request({
    url: cloudUrl + 'deployment_detail/',
    headers: baseHeaders,
    params: params,
    method: 'put'
  })
}

// 更新Deployment yaml
export const updateDeploymentYaml = (data) => {
  return axios.request({
    url: cloudUrl + 'deployment/update/',
    headers: baseHeaders,
    data: data,
    method: 'post'
  })
}

// 删除deployment
export const deleteDeployment = (params) => {
  return axios.request({
    url: cloudUrl + 'deployment_detail/',
    headers: baseHeaders,
    params: params,
    method: 'delete'
  })
}

export const saveDeployment = (data) => {
  return axios.request({
    url: cloudUrl + 'deployment/create',
    headers: baseHeaders,
    data: data,
    method: 'post'
  })
}

// 查询Deployment详情
export const getDeploymentDetail = (params) => {
  return axios.request({
    url: cloudUrl + 'deployment_detail/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}
